'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormattedMonth;

function getFormattedMonth(value) {
  try {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long'
    }).format(value);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return '';
  }
}